import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import { VerifyEmailOTPRequestType } from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

interface UseVerifyEmailOTPAPIAPIInterface {
  verifyEmailOTPAPI: UseMutateAsyncFunction<
    void,
    unknown,
    VerifyEmailOTPRequestType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useVerifyEmailOTPAPI = (): UseVerifyEmailOTPAPIAPIInterface => {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const verifyEmailOTP = (request: VerifyEmailOTPRequestType) => {
    return ibUserAccountsAPIService.verifyEmailOTP(request);
  };

  const { mutateAsync, error, status } = useMutation(verifyEmailOTP, {
    mutationKey: ['verifyEmailOTPAPI']
  });

  return {
    verifyEmailOTPAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useVerifyEmailOTPAPI };
